var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center px-6 lg:px-3 xl:px-2 py-1 border rounded-full whitespace-nowrap max-w-xxs",class:`${_vm.borderClass} text-${_vm.color}-700 h-${_vm.height}`},[_c('h6',{staticClass:"px-2"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }